import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { CcParamsGen } from "@app/cc-params-gen/cc-params-gen"
import { COMMON_IMPORTS } from "../common-imports"
import { NgTemplateOutlet } from "@angular/common"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { GenSelectComponent } from "@app/gen-inputs/gen-select/gen-select.component"
import { CcParamsSmsComponent } from "@app/cc-params-sms/cc-params-sms.component"
import { CcSectionsComponent } from "@app/cc-sections/cc-sections.component"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"

const numberWithLeadingZero = (num) => (num < 10 ? "0" : "") + num //fills numbers to have leading zeros

@Component({
	selector: "app-cc-params-journal",
	imports: [
		COMMON_IMPORTS,
		NgTemplateOutlet,
		LangValPipe,
		GenSelectComponent,
		CcParamsSmsComponent,
		CcSectionsComponent,
		GenInputComponent,
		GenButtonGroupComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./cc-params-journal.component.html",
})
export class CcParamsJournalComponent extends CcParamsGen {
	//inheriting most functions and fields!
	saveObjName: string = "journal" //which part to save while updating
	hoursOPts: any[] = Array(25)
		.fill(1)
		.map((n, k) => ({
			id: `${numberWithLeadingZero(k)}:00`,
			name: `${numberWithLeadingZero(k)}:00`,
		})) //hours from 01:00 to 23:00
	patienttypes: any[] = []
	apiLink: string = ""

	ngOnInit() {
		this.patienttypes = this.store.getSiteDataTable("patienttypes")
		const timeFields = [
			"calendar_end_time",
			"time_on_holiday_evening",
			"calendar_start_time",
		] //time fields to change the display to HH:MM if needed
		timeFields.forEach((timeField) => {
			//for each time field, if has seconds (HH:MM:SS) - rewrite without them (HH:MM)
			let split = this.configcliniq[timeField].split(":")
			if (split.length == 3) {
				//has seconds
				this.configcliniq[timeField] = `${split[0]}:${split[1]}` //rewrite only with hours and minutes (first 2 elements)
			}
		})
		this.getApiKeys()
	}
	validateEntireForm() {
		//validate all fields and detrmine if can be submitted (or has errors)
		let validationFields = {}
		if (this.configcliniq?.consent_to_sms_contract == "yes") {
			validationFields = {
				name_on_message: { not_empty: true, regex: /^([a-zA-Z0-9- .]){1,11}$/ },
			}
		}
		this.isFormSubmittable = this.validator.validateEntireForm(
			this.configcliniq,
			this.errors,
			validationFields
		)
	}
	async getApiKeys() {
		this.apiLink = await this.store.getApiLink("guest-cal")
	}

	async copyApiLink() {
		navigator.clipboard.writeText(this.apiLink)
		this.modalService.openToast("copy_link")
		//window.open(this.apiLink, "_blank", 'rel="external"')
	}
}
